<template>
  <div class="box">
    <div class="flex items-center h-16 px-5 border-b border-gray-200 dark:border-dark-5">
      <PageHeader class="font-medium text-base mr-auto" :title="title" />
      <Button
        v-if="btnName"
        @click="$emit('click')"
        class="border text-gray-700 dark:bg-dark-5 dark:text-gray-300"
        >{{ btnName }}</Button
      >
      <Button
        v-if="btnNameSecond"
        @click="$emit('clickSecondButton')"
        class="border text-gray-700 dark:bg-dark-5 dark:text-gray-300 ml-2"
        >{{ btnNameSecond }}</Button
      >
    </div>
    <div class="p-5">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/ui/PageHeader';
import Button from '@/components/ui/button/Button';

export default {
  props: {
    title: String,
    btnName: String,
    btnNameSecond: {
      type: String,
      default: '',
    },
  },

  components: {
    PageHeader,
    Button,
  },
};
</script>
